import React, { useState, useEffect, useContext } from 'react';
import './sidebar.css';
import styled from 'styled-components';
import { Link,withRouter } from 'react-router-dom';
import { AuthContext } from '../../../auth';
import Parse from 'parse';



const StyledDiv = styled.div`
border-bottom: 3px solid #65cdf0;
`
const Styledh1 = styled.h1`
color: #65cdf0;
font-size: 26px;
padding-top: 9px;
margin:auto
`
const Styledspan = styled.span`
color: #65cdf0;
`

const Styledbutton = styled.button`
background: #e9e9e9;
border: none;
padding: 10px;
border-radius: 12px;
color: #75cbfd;
margin: 4%
`
const Counsellorsidebar = (props) => {

    useEffect(() => {
        const User = Parse.Object.extend("User");
        const query = new Parse.Query(User);
        query.get(logedinuser).then((counsellor) => {
            setName(counsellor.get("name"));
        })


}, [])

    let [logedinuser, setLogedinuser] = useContext(AuthContext);
    let [name,setName] = useState('');
    let data;

    


const logout = () => {
    Parse.User.logOut().then(() => {
        var currentUser = Parse.User.current();  // this will now be null
        console.log(currentUser);
        setLogedinuser(null);
        props.history.replace("/");
    })
}

if (logedinuser == null) {
    data =
        <div className="navhead">
            <Link to="/counsellor/login" >Login</Link>
            <div>
                <p>Dont have an account?</p>
                <Link to="/counsellor/register">Register here</Link>
            </div>
        </div>
} else {
    data =
        <div className="header" >
            <div className="media mb-3">
                <img class="mr-3 ml-3 mt-0" src="/assests/images/user.png" height="50" alt="user img" />
                <div className="media-body">
                    <h4 className="mb-0 mt-2" style={{ color: "#65cdf0" }}>Dr. {name}</h4>
                </div>
            </div>
            <div className="mr-1">
                <br />
                <Styledbutton onClick={logout}>Log out</Styledbutton>
            </div>
        </div>
}

const closeNav = () => {
    document.getElementById("mySidenav").style.width = "0";
}

const openNav = () => {
    document.getElementById("mySidenav").style.width = "250px";
}

return (
    <StyledDiv>

        <div id="mySidenav" className="sidenav">
            <a href="javascript:void(0)" className="closebtn" onClick={closeNav}>&times;</a>

            {data}
            <div className="navcontent">
                {/* <Link to="/"><i className="fas fa-columns"></i>     CONNECTION-AID</Link> */}
                <Link to="/counsellor/"><i className="fas fa-columns"></i>     DASHBOARD</Link>
                {/* <Link to="/counsellorchat"><i className="far fa-laugh"></i>     CHAT WITH COUNSELLOR //coming soon</Link> */}
                {/* <Link to="/counsellor/"><i className="fas fa-book-open"></i>       PATIENT PROFILES</Link> */}
                <Link to="/offline/members"><i className="fas fa-users"></i>       OFFLINE APPOINTMENTS</Link>
                <Link to="/counsellor/ethics"><i className="fas fa-users"></i>    ETHICS</Link>
                {/* <Link to="/counsellor/diagnosis"><i className="far fa-laugh"></i>    DIAGNOSTIC CRITERIA</Link> */}
                <Link to="/counsellor/queries"><i className="fas fa-users"></i>    SUPPORT/QUERY</Link>

            </div>
        </div>
        <div className="container d-flex ">
            <Styledspan onClick={openNav} >&#9776;</Styledspan>
            <Styledh1>{props.head}</Styledh1>
            {console.log(props.head)}
        </div>



    </StyledDiv>

)
}



export default withRouter(Counsellorsidebar);

